import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import themes from '../../theme/theme.module.css';
import styles from './highlight-icon.module.css';
export const HighlightIcon = ({ children, theme, className })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: classNames(styles.container, themes[theme], className),
        children: children
    });
};

//# sourceMappingURL=highlight-icon.js.map